import { useSearchFilter } from './useSearchFilter';
import { useTicketUpdateForm } from './useTicketUpdateForm';
import { useTicketUpdate } from './useTicketUpdate';
import { useDownload } from './useDownload';
import * as XLSX from 'xlsx';

export type { Tag } from './useSearchFilter';

export function useEdit() {
    const searchFilter = useSearchFilter();
    const ticketUpdateForm = useTicketUpdateForm();
    const ticketUpdate = useTicketUpdate({
        results: searchFilter.results,
        ticketData: ticketUpdateForm.ticketData,
        subject: ticketUpdateForm.subject,
        comment: ticketUpdateForm.comment,
        typeComment: ticketUpdateForm.typeComment,
        status: ticketUpdateForm.status,
        type: ticketUpdateForm.type,
        applyFilter: searchFilter.applyFilter,
        resetForm: ticketUpdateForm.resetForm
    });
    const download = useDownload({
        results: searchFilter.results,
        selectedSearch: searchFilter.selectedSearch
    });

      const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (file) {
          if (file.name.endsWith('.xlsx') || file.name.endsWith('.xls')) {
            const reader = new FileReader();
            reader.onload = (e) => {
              const data = new Uint8Array(e.target?.result as ArrayBuffer);
              const workbook = XLSX.read(data, { type: 'array' });
              const sheetName = workbook.SheetNames[0];
              const worksheet = workbook.Sheets[sheetName];
              const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
    
              const ids: string[] = [];
              jsonData.forEach((row: any) => {
                if (Array.isArray(row)) {
                  row.forEach((cell: any) => {
                    if (typeof cell === 'number' || (typeof cell === 'string' && !isNaN(Number(cell)))) {
                      ids.push(String(cell));
                    }
                  });
                }
              });
    
              searchFilter.setSearchInput(ids.join(', '));
            };
            reader.readAsArrayBuffer(file);
          } else {
            const reader = new FileReader();
            reader.onload = (e) => {
              const text = e.target?.result as string;
              const ids = text.split(/\s+|,/).map(id => id.trim()).filter(id => id && !isNaN(Number(id))).map(id => id).join(', ');
              searchFilter.setSearchInput(ids);
            };
            reader.readAsText(file);
          }
        }
      };

    return {
        ...searchFilter,
        ...ticketUpdateForm,
        ...ticketUpdate,
        ...download,
        handleFileChange
    }
}